import React, { useState } from "react";

export default function TelefonSMSModule({tab, setTab}: {tab: string, setTab: (tab: string) => void}) {
  return (
    <div className="min-h-screen bg-slate-50 p-8 text-slate-900">
      <h1 className="text-2xl font-bold mb-6">Telefon & SMS</h1>

      {/* SERVICE OVERVIEW */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
        {/* TELEFONI */}
        <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
          <h2 className="text-lg font-semibold mb-2">Telefoni</h2>
          <p className="text-sm text-slate-600 mb-4">
            Administrer innkommende og utgående anrop.
          </p>
          <button className="px-4 py-2 bg-slate-900 text-white rounded-lg text-sm hover:bg-black">
            Administrer telefoni
          </button>
        </div>

        {/* SMS */}
        <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
          <h2 className="text-lg font-semibold mb-2">SMS</h2>
          <p className="text-sm text-slate-600 mb-4">
            Front SMS, Link Mobility, Chamcore SMS.
          </p>
          <button className="px-4 py-2 bg-slate-900 text-white rounded-lg text-sm hover:bg-black">
            Administrer SMS
          </button>
        </div>

        {/* KAMAILIO / VOIP */}
        <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
          <h2 className="text-lg font-semibold mb-2">Chamcore VOIP</h2>
          <p className="text-sm text-slate-600 mb-4">
            SIP, Kamailio, routing, IVR og avansert telefoni.
          </p>
          <button onClick={() => setTab("Administer voip")} className="px-4 py-2 bg-slate-900 text-white rounded-lg text-sm hover:bg-black">
            Administrer VOIP
          </button>
        </div>
      </div>

      {/* PHONE NUMBERS */}
      <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm mb-8">
        <h2 className="text-lg font-semibold mb-4">Aktive system nummer IVR </h2>
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left border-b border-slate-200 text-slate-500">
              <th className="py-2 pr-4">Nummer</th>
              <th className="py-2 pr-4">Type</th>
              <th className="py-2 pr-4">Status</th>
              <th className="py-2 pr-4">Dato lagt til</th>
              <th className="py-2">Handling</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b border-slate-100">
              <td className="py-2 pr-4">+45 92453000</td>
              <td className="py-2 pr-4">Mobil</td>
              <td className="py-2 pr-4">Aktiv</td>
              <td className="py-2 pr-4">2022-09-02 06:00</td>
              <td className="py-2">
                <button className="text-indigo-600 text-xs hover:underline">Administrer</button>
              </td>
            </tr>
            <tr>
              <td className="py-2 pr-4">+1 315 644 2581</td>
              <td className="py-2 pr-4">Mobil</td>
              <td className="py-2 pr-4">Aktiv</td>
              <td className="py-2 pr-4">2021-09-29 10:46</td>
              <td className="py-2">
                <button className="text-indigo-600 text-xs hover:underline">Administrer</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* ADD NUMBER SECTION */}
      <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm">
        <h2 className="text-lg font-semibold mb-4">Legg til telefonnummer</h2>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 mb-6">
          <select className="border border-slate-300 rounded-lg px-3 py-2 text-sm">
            <option>United States</option>
            <option>Norway</option>
            <option>Sweden</option>
          </select>

          <input
            type="text"
            className="border border-slate-300 rounded-lg px-3 py-2 text-sm"
            placeholder="Area code"
          />

          <select className="border border-slate-300 rounded-lg px-3 py-2 text-sm">
            <option>Mobile</option>
            <option>Landline</option>
          </select>

          <button className="px-4 py-2 bg-indigo-600 text-white rounded-lg text-sm hover:bg-indigo-700">
            Søk
          </button>
        </div>

        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-slate-500 border-b border-slate-200">
              <th className="py-2 pr-4">Nummer</th>
              <th className="py-2 pr-4">Type</th>
              <th className="py-2 pr-4">Funksjoner</th>
              <th className="py-2">Handling</th>
            </tr>
          </thead>
          <tbody>
            {["+46764796790", "+46723449792", "+46734745716"].map((num) => (
              <tr key={num} className="border-b border-slate-100">
                <td className="py-2 pr-4">{num}</td>
                <td className="py-2 pr-4">Mobil</td>
                <td className="py-2 pr-4">💬 SMS</td>
                <td className="py-2">
                  <button className="bg-emerald-600 text-white px-3 py-1.5 rounded-lg text-xs hover:bg-emerald-700">
                    Kjøp SIP nummer
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
